import { useParams } from "react-router-dom";
import PageLayout from "../../layouts/PageLayout";
import {
  generateChassis,
  stockListFormatter,
  useGetStockListQuery
} from "../../utils/stockList.utils";
import styled from "styled-components";
import StockListViewContainer, { StockListViewContainerSkeleton } from "./StockListViewContainer";
import Skeleton from "react-loading-skeleton";

export default function StockListViewPage() {
  const { sku } = useParams();

  const { loading, data } = useGetStockListQuery({
    query: `?sku=${sku}`,
    options: {
      enabled: !!sku
    },
    key: `StockListView-${sku}`
  });

  let formattedData = stockListFormatter(data);

  const fullChassis = generateChassis(formattedData);

  const breadCrumbs = [
    {
      name: "Stock List",
      link: "/stock-list"
    },
    {
      name: loading ? "Loading..." : fullChassis
    }
  ];

  const isLoading = loading;

  return (
    <PageLayout
      title={isLoading ? "Loading..." : fullChassis}
      breadCrumbs={breadCrumbs}
      style={{ hasCardBg: false, className: "pt-4", cardBodyClass: "p-0" }}
      loading={isLoading}>
      {isLoading ? <StockListViewContainerSkeleton /> : <StockListViewContainer data={data} />}
    </PageLayout>
  );
}

export const OverviewItem = ({ label, value }) => {
  return (
    <li className="d-flex justify-content-between mb-2 border-bottom pb-2">
      <div>{label ?? ""}</div>
      <div>{value ?? ""}</div>
    </li>
  );
};

// Skeleton
export const OverviewItemSkeleton = () => {
  return (
    <li className="d-flex justify-content-between mb-2 border-bottom pb-2">
      <div className="w-100">
        <Skeleton width={`100%`} height={10} />
      </div>
    </li>
  );
};

export const SkuContainer = styled.p`
  font-size: 0.9rem;
  color: rgb(var(--primary) / 0.8);
  transition: color 0.3s ease;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    color: rgb(var(--primary) / 1);
  }
`;

export const TitleContainer = styled.p`
  font-size: 1.2rem;
  color: rgb(var(--dark) / 1);
  transition: color 0.3s ease;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: rgb(var(--primary) / 1);
  }
`;

export const OverviewContainer = styled.ul`
  li:last-of-type {
    border-bottom: 0 !important;
  }
`;
